import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { useSelector } from "react-redux";
import useDebouncedSearch from "../hooks/useDebouncedSearch";
import styles from "../styles/adminBrandsComponent.module.css";
import btnStyles from "../styles/globalButtonStylng.module.css";
import { BrandInstance } from "../utils/brandClass";
import { ProductInstance } from "../utils/productClass";
import { SearchInstance } from "../utils/searchClass";
import { ImageScaleAndCropComponent } from "./imageScaleAndCropComponent";
export const AdminAddProductFormComponent = ({
  closeForm,
  data,
  setInputs,
}: {
  closeForm: Function;
  data: any;
  setInputs: any;
}) => {
  const [productDetails, setProductDetails] = useState<Record<string, any>>({
    categoryId: 1, // Assuming IDs are strings. Adjust accordingly.
    subCategoryId: 1,
    thcContent: 0,
    cbdContent: 0,
    cbnContent: 0,
  });
  const { categories, subCategories, isLoading } = useSelector((state: any) => state.product);

  const { searchType, search, searchResults } = useSelector((state: any) => state.search);

  const { searchInput, debouncedSearchTerm, setSearchInput } = useDebouncedSearch();

  const [canSubmit, setCanSubmit] = useState(false);
  const requiredFields = ["name", "brandId", "categoryId", "subCategoryId", "thcContent", "cbdContent", "cbnContent"];
  const [hideBorder, setHideBorder] = useState(true);
  const [categoryLabel, setCategoryLabel] = useState("");

  //for adding images
  const [selectedThumbnail, setSelectedThumbnail] = useState<File | null>(null);
  const [selectedDisplayImage, setSelectedDisplayImage] = useState<File | null>(null);
  const [isCropVisible, setIsCropVisible] = useState<{
    thumb: boolean;
    display: boolean;
  }>({
    thumb: false,
    display: false,
  });
  const [imageSrc, setImageSrc] = useState<{
    thumb: string | null;
    display: string | null;
  }>({
    thumb: null,
    display: null,
  });

  useEffect(() => {
    if (debouncedSearchTerm) {
      SearchInstance.setSearchQuery(debouncedSearchTerm);
    }
  }, [debouncedSearchTerm]);

  const handleSearchQueryChange = (event: any) => {
    setSearchInput(event.target.value);
  };
  useEffect(() => {
    const isFilled = requiredFields.every(
      (field) => productDetails[field] !== undefined && productDetails[field] !== null,
    );
    setCanSubmit(isFilled);
    console.log("PRODUCT DETAILS", productDetails);
  }, [productDetails]);

  useEffect(() => {
    SearchInstance.setSearchType("brand", setSearchInput);
    if (categories.length < 1) {
      console.log("in startup getting categories", categories, subCategories);
      ProductInstance.getProductCategories();
      ProductInstance.getProductSubCategories(productDetails.categoryId);
    }
  }, [isLoading]);

  useEffect(() => {
    (async () => {
      await ProductInstance.getProductCategories();
      console.log("categories:", categories);
      await ProductInstance.getProductSubCategories(productDetails.categoryId);
    })();
  }, [productDetails.categoryId]);

  const handleImageCropped = async (croppedImageUrl: string, type: "thumb" | "display") => {
    // Convert the cropped image URL to a Blob
    const response = await fetch(croppedImageUrl);
    const blob = await response.blob();
    console.log("HERE BE OUR BLOB", blob);
    // Create a File object from the Blob
    const fileExt = blob.type.split("/")[1]; // Extracts the file extension from the MIME type
    const fileName = `cropped_image.${fileExt}`; // Constructs a file name
    const croppedImageFile = new File([blob], fileName, { type: blob.type });
    // Generate a URL for the cropped image file
    const croppedImageURL = URL.createObjectURL(croppedImageFile);
    console.log("HERE BE THE IMAGE FILE", croppedImageFile);
    console.log("IMAGE URL BE HERE", croppedImageURL);

    // Update the appropriate state with the new File object
    if (type === "thumb") {
      setSelectedThumbnail(croppedImageFile);
      setImageSrc((prev) => ({ ...prev, thumb: croppedImageURL }));
    } else if (type === "display") {
      setSelectedDisplayImage(croppedImageFile);
      setImageSrc((prev) => ({ ...prev, display: croppedImageURL }));
    }

    // Hide the cropping modal
    setIsCropVisible((prev) => ({ ...prev, [type]: false }));
  };

  const handleThumbnailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    handleImageChange(event, "thumb");
  };

  const handleDisplayImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    handleImageChange(event, "display");
  };

  const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>, type: "thumb" | "display") => {
    const file = event.target.files ? event.target.files[0] : null;
    console.log("HERE BE DEH FILE", file);
    if (file) {
      const fileURL = URL.createObjectURL(file);
      setSelectedDisplayImage(file);
      //just set for both thumbnail and display
      setImageSrc((prev) => ({ ...prev, ["thumb"]: fileURL }));
      setImageSrc((prev) => ({ ...prev, ["display"]: fileURL }));
      setIsCropVisible((prev) => ({ ...prev, [type]: true }));
    }
  };

  const handleSubmitProduct = async (e: any) => {
    // console.log('submitting product');
    e.preventDefault();
    const data = {
      product: productDetails, //formData,
      brandId: productDetails.brandId, //activeBusiness.id,
      displayImg: selectedDisplayImage,
      avatarImg: selectedDisplayImage, //selectedThumbnail, <<if we have another image input change to htat var
    };
    console.log("OUR DATA ON SUBMITTING", data);
    const addRes = await BrandInstance.addProduct(data);
    if (addRes) {
      // console.log('Product added successfully');
      console.log("OUR RESULT", addRes);
      closeForm(); //onClose();
    } else {
      // console.log('Product not added');
      console.error("Error submitting product:");
    }
  };

  useEffect(() => {
    if (searchResults.length === 0) {
      setHideBorder(true);
    } else {
      setHideBorder(false);
    }
  }, [searchResults]);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setProductDetails({
      ...productDetails,
      [name]: value,
    });
  };

  return (
    <Form className={styles.wrapper} id="addProductForm">
      <Form.Group className="mb-3" controlId="formBasicName">
        <Form.Label>Product Name</Form.Label>
        <Form.Control type="text" name="name" placeholder="Product Name" onChange={handleInputChange} />
      </Form.Group>
      <Form.Group className="mb-3" controlId="formBrandSearch">
        <Form.Label>Brand Name (Select from dropdown)</Form.Label>
        <Form.Control
          type="text"
          name="searchInput"
          placeholder="Search for Brand"
          value={searchInput}
          onChange={handleSearchQueryChange}
        />
        <div className={`${styles.dropdown} ${hideBorder ? styles.hideBorder : ""}`}>
          {searchResults.map(
            (result: any) =>
              result.name !== searchInput && (
                <option
                  className={styles["option"]}
                  key={result.id}
                  value={result.id}
                  title={result.name}
                  onClick={(e) => {
                    setProductDetails({
                      ...productDetails,
                      brandId: result.id,
                    });
                    setSearchInput(result.name);
                    setHideBorder(true);
                  }}
                >
                  {result.name}
                </option>
              ),
          )}
        </div>
      </Form.Group>
      <Form.Group className="mb-3" controlId="formBasicState">
        <Form.Label>Product Description</Form.Label>
        <Form.Control
          type="text"
          name="description"
          placeholder="description of product"
          onChange={handleInputChange}
        />
      </Form.Group>
      <Form.Group>
        <Form.Label>Product Image</Form.Label>
        <div className={styles.thumbnailWrapper}>
          <>
            {isCropVisible.display && (
              <ImageScaleAndCropComponent
                setSrc={(croppedImgUrl: any) => {
                  handleImageCropped(croppedImgUrl, "display");
                  //handleImageCropped(croppedImgUrl, 'thumb');
                }}
                imageType="displayImage"
                src={imageSrc.display}
                handleClose={() => setIsCropVisible((prev) => ({ ...prev, display: false }))}
              />
            )}
          </>
          <div
            style={{
              margin: "0 auto 10px auto",
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {imageSrc.display ? (
              <img
                src={
                  imageSrc.display
                    ? imageSrc.display
                    : selectedDisplayImage
                      ? URL.createObjectURL(selectedDisplayImage)
                      : "https://via.placeholder.com/150"
                }
                alt="display image"
              />
            ) : (
              <div className={styles.imagePlaceHolder}>
                <h3>1080 x 1080</h3>
              </div>
            )}
          </div>
          <input type="file" onChange={handleDisplayImageChange} accept="image/png, image/jpeg, image/jpg" />
          <p>
            Set the Product Display image. Please select an image that is 1080 x 1080. Only *.png, *.jpg and *.jpeg
            image files are accepted
          </p>
        </div>
      </Form.Group>
      {/* CATEGORY */}
      <Form.Group className="mb-3" controlId="formBrandSearch"></Form.Group>
      <Form.Group className="mb-3" controlId="formProductCategory">
        <Form.Label htmlFor="">Product Category</Form.Label>
        <div>
          <select
            name=""
            id=""
            onChange={(e) => {
              const selectedOption = JSON.parse(e.target.value);
              setCategoryLabel(selectedOption.name);
              setProductDetails({
                ...productDetails,
                categoryId: Math.floor(Number(selectedOption.id)),
              });
            }}
          >
            {categories.map((category: any, index: number) => (
              <option key={index} value={JSON.stringify({ name: category.name, id: category.id })}>
                {category.name}
              </option>
            ))}
          </select>
        </div>
      </Form.Group>
      {/* SUB CATEGORY */}
      <Form.Group style={{ marginTop: 20 }} className={styles.categorySelect}>
        <Form.Label htmlFor="">Product Sub-Category</Form.Label>
        <div>
          <select
            name=""
            id=""
            onChange={(e) =>
              setProductDetails({
                ...productDetails,
                subCategoryId: Math.floor(Number(e.target.value)),
              })
            }
          >
            {subCategories.map((subCategory: any) => (
              <option value={subCategory.id}>{subCategory.name}</option>
            ))}
          </select>
        </div>
      </Form.Group>
      {/* THC CBD and CBN content inputs */}
      <Form.Group
        style={{
          marginTop: 20,
          marginBottom: 20,
          flexDirection: "row",
          justifyContent: "flex-start",
          gap: 20,
        }}
        className={styles.categorySelect}
      >
        <div style={{ display: "flex", flexDirection: "column" }}>
          <label htmlFor="">THC Content {categoryLabel === "Edibles" ? "(mg)" : "(%)"}</label>
          <input
            type="number"
            name="thcContent"
            max="100"
            value={productDetails.thcContent}
            onChange={handleInputChange}
          />
        </div>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <label htmlFor="">CBD Content {categoryLabel === "Edibles" ? "(mg)" : "(%)"}</label>
          <input type="number" name="cbdContent" value={productDetails.cbdContent} onChange={handleInputChange} />
        </div>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <label htmlFor="">CBN Content {categoryLabel === "Edibles" ? "(mg)" : "(%)"}</label>
          <input type="number" name="cbnContent" value={productDetails.cbnContent} onChange={handleInputChange} />
        </div>
      </Form.Group>
      <Button
        className={btnStyles.Submit}
        disabled={!canSubmit}
        variant="primary"
        type="submit"
        onClick={handleSubmitProduct}
      >
        Create Product
      </Button>
    </Form>
  );
};
